import { fetchDAProDetail, proDataCache } from './fetchDAProDetail';

export const TRACKED_PRO_PRELOAD_LIMIT = 8;
export const TRACKED_PRO_PRELOAD_CONCURRENCY = 1;
export const TRACKED_PRO_PRELOAD_TIMEOUT_MS = 10000;

function uniqueTrackedIds(trackedDAs, limit) {
  const ids = [];
  const seen = new Set();

  for (const da of Array.isArray(trackedDAs) ? trackedDAs : []) {
    const id = da?.id;
    if (!id || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
    if (ids.length >= limit) break;
  }

  return ids;
}

export async function preloadTrackedDAProDetails(
  trackedDAs,
  {
    userId,
    fetchFn = fetchDAProDetail,
    cache = proDataCache,
    limit = TRACKED_PRO_PRELOAD_LIMIT,
    concurrency = TRACKED_PRO_PRELOAD_CONCURRENCY,
    timeoutMs = TRACKED_PRO_PRELOAD_TIMEOUT_MS,
  } = {}
) {
  const ids = uniqueTrackedIds(trackedDAs, limit);
  if (ids.length === 0) return { attempted: 0 };

  const cacheScope = userId || 'user';
  let cursor = 0;
  let attempted = 0;

  const worker = async () => {
    while (cursor < ids.length) {
      const id = ids[cursor];
      cursor += 1;

      if (cache?.has?.(`${cacheScope}:${id}`)) continue;
      attempted += 1;

      try {
        await fetchFn(id, { cacheScope, timeoutMs, recordCircuitFailure: false });
      } catch {
        // Preloading is opportunistic. The card/detail view will show retry UI if needed.
      }
    }
  };

  const workerCount = Math.max(1, Math.min(concurrency, ids.length));
  await Promise.all(Array.from({ length: workerCount }, worker));

  return { attempted };
}
